import { render, staticRenderFns } from "./RipaCpraReport.vue?vue&type=template&id=4b4e57ac"
import script from "./RipaCpraReport.vue?vue&type=script&lang=js"
export * from "./RipaCpraReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports